import { useActionState } from "react";
import { updateTraitAction } from "@/actions/traits";
import { Button } from "@/components/Button";
import { FormCell, FormCheckboxCell, StaticCell } from "@/components/FormCell";
import styles from "@/components/FormRow.module.css";
import { LinkButton } from "@/components/LinkButton";
import { initialFormState } from "@/lib/formState";
import { useFormRedirect } from "@/lib/useFormRedirect";

const FORM_ID = "trait-edit";

type TraitEditRowProps = {
  // The listing owns the rows, so a save has to tell it to read again.
  onSaved: () => void;
  id: number;
  code: string;
  label: string | null;
  selfDeclareQuestion: string | null;
  isOnboardingQuestion: boolean;
  sortOrder: number;
};

export const TraitEditRow = ({
 onSaved,
  id,
  code,
  label,
  selfDeclareQuestion,
  isOnboardingQuestion,
  sortOrder,
}: TraitEditRowProps) => {
  const [state, formAction, isPending] = useActionState(
    updateTraitAction.bind(null, id),
    initialFormState,
  );

  useFormRedirect(state, onSaved);

  return (
    <>
      <StaticCell value={code} isRowHeader />
      <FormCell
        form={FORM_ID}
        name="label"
        label="Label"
        defaultValue={state.values.label ?? label ?? ""}
        errors={state.fieldErrors.label}
      />
      <FormCell
        form={FORM_ID}
        name="selfDeclareQuestion"
        label="Self-declare question"
        defaultValue={
          state.values.selfDeclareQuestion ?? selfDeclareQuestion ?? ""
        }
        errors={state.fieldErrors.selfDeclareQuestion}
      />
      <FormCheckboxCell
        form={FORM_ID}
        name="isOnboardingQuestion"
        label="Ask at signup"
        defaultChecked={isOnboardingQuestion}
      />
      <FormCell
        form={FORM_ID}
        name="sortOrder"
        label="Sort order"
        inputMode="numeric"
        defaultValue={state.values.sortOrder ?? String(sortOrder)}
        errors={state.fieldErrors.sortOrder}
      />
      {/* Required by, Granted by, Status and the actions column: read-only
          while editing. */}
      <td className={styles.actions} colSpan={4}>
        <form id={FORM_ID} action={formAction} hidden />
        <Button
          type="submit"
          form={FORM_ID}
          variant="primary"
          disabled={isPending}
        >
          {isPending ? "Saving..." : "Save"}
        </Button>
        <LinkButton href="/traits" variant="secondary" shouldReplaceHistory>
          Cancel
        </LinkButton>
      </td>
    </>
  );
};
